import type { iProduct } from "@sdk/bookings/booking-model";
import type { AccountingListProductContext } from "@/@sdk/accounting/accounting-list-report.models";

export function formatProductLabelFromProduct(
  product: iProduct | undefined,
  productId?: string
): string {
  if (!product) return productId ?? "—";
  const type = String(product?.type ?? "").trim();
  const legData = product as any;
  const name =
    product?.tour?.data?.name ??
    legData?.excursion?.data?.excursionName ??
    legData?.excursion?.data?.name ??
    legData?.attraction?.data?.attractionName ??
    legData?.attraction?.data?.name ??
    legData?.accommodation?.data?.accommodationName ??
    legData?.accommodation?.data?.name ??
    legData?.cruise?.data?.shipName ??
    legData?.cruise?.data?.name ??
    legData?.car?.data?.rentalCompany ??
    legData?.car?.data?.name ??
    legData?.transfer?.data?.heading ??
    legData?.transfer?.data?.name ??
    legData?.rail?.data?.operator ??
    legData?.rail?.data?.name ??
    legData?.flight?.data?.[0]?.airline ??
    legData?.flight?.data?.name ??
    "";
  return [type, name].filter(Boolean).join(" · ") || productId || "—";
}

export function formatProductContextLabel(
  product: AccountingListProductContext | undefined,
  productId?: string
): string {
  return product?.label ?? productId ?? "—";
}
